/* Requirement: UrlId (access token) is always 24 characters! */
export const parseUrlId = (urlId: string | string [] | undefined) : string | undefined => {
  if (!urlId) return undefined;
  if (Array.isArray(urlId)) throw Error('Invalid urlId');
  return urlId.substring(0, 24);
};

export const parseLang = (lang: string | string[]) : string | undefined => {
  if (!lang) return undefined;
  if (Array.isArray(lang)) throw Error('Invalid lang');

  const languageCode = lang.toLowerCase();

  if (languageCode === 'pt') return 'pt-br';

  return languageCode;
};
